import React, { useState, useEffect } from 'react';
import { Form, Select, Input } from 'antd';
import { useDispatch, ReactReduxContext } from 'react-redux';
// import { DownOutlined } from '@ant-design/icons';
// import mapper from 'object-mapper';

import { editOrdersInfoM, fetchProductsPriceIfNeeded } from './../../../Actions/Orders';

import SupplierInput from './../../Common/Search/Input';

const { Option } = Select;

const TSelect = (props) => {
  const dispatch = useDispatch();
  const handleChange = (value) => {
    if (value.key === '9999') {
      return props.otherHandle(true);
    }
    const list = props.list;
    const _s = list.filter(item => String(item.key || '') === String(value.key || ''));
    props.toggleEdit({ name: 'current_suppliers', value: { key: value.key, label: value.label } });
    props.toggleEdit({ name: 'supplier_suffix_id', value: '' });
    // props.onChange({ current_suppliers1: { key: value.key, label: value.label } });
    if (!_s[0]) { return false; }
    const { destination_id, unit_id, pp_id, oi_id, sku_code } = _s[0];
    if(oi_id!=undefined){
      
      dispatch(editOrdersInfoM({
        supplier_id: value.key,
        destination: destination_id,
        unit_id: unit_id,
        pp_id: pp_id
      }, oi_id, 'info'));
    }
    dispatch(fetchProductsPriceIfNeeded(
      sku_code,
      value.key,
      props.data.o_id,
      props.data.oi_id,
      props.data.departure_date || props.data.booking_date
    ));
  }
  // console.log(props.data);
  return (
    <Select onChange={handleChange} value={props.value} labelInValue dropdownMatchSelectWidth={false} style={props.style ? props.style : { width: '100%' }}>
      {
        props.data.map((item, index) => {
          return (
            <Option key={String(item.key)}>{item.label}</Option>
          );
        })
      }
      <Option key="9999">其它</Option>
    </Select>
  );
};
// props.otherHandle
const SInput = (props) => {
  const { toggleEdit, onChange, setContacts, ..._props } = props;
  const [suppliers, setSuppliers] = useState([]);
  return (
    <SupplierInput
      {..._props}
      onChange={(value) => {
        if (!value) { value = { key: '', label: '' } }
        toggleEdit({ name: 'current_suppliers', value: { key: value.key, label: value.label } });
        toggleEdit({ name: 'supplier_suffix_id', value: '' });
        setContacts(suppliers.filter(item => String(item.key) === String(value.key)).map(item => JSON.parse(item.contacts))[0] || []);
        onChange(value);
      }}
      onSearchAfter={(list, value) => {
        setSuppliers((list || []).filter(item => JSON.parse(item.contacts || '[]').length > 0));
      }}
      url='/api/supplier/name' map={{ 'data[].s_id': '[].key', 'data[].company': '[].label', 'data[].contacts': '[].contacts' }} dropdownMatchSelectWidth={false} />
  );
}

const SuffixSelect = (props) => {
  const { toggleEdit, onSearchAfter, ..._props } = props;
  const [v, setV] = useState([]);
  const [data, setData] = useState([]);
  // useEffect(() => {
  //   setV(String(props.value.key) === '' || props.value.length === 0 ? [] : props.value);
  // }, [props.value]);
  useEffect(() => {
    setData(props.data);
  }, [props.data]);
  return (
    <Select {..._props} value={v.length === 0 ? _props.value : v} labelInValue dropdownMatchSelectWidth={false} allowClear={true} onChange={(e) => {
      if (!e) {
        e = { key: '', label: '' };
      }
      setV(e);
      toggleEdit({ name: 'supplier_suffix_id', value: e.key });
    }}>
      {
        (data || []).map((item, index) => {
          return (
            <Option key={String(item.ID)}>{item.name}</Option>
          );
        })
      }
    </Select>
  );
}


export default class SupplierMenu extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      'otherInput': false,
      'contacts': [],
    };
  }

  setContacts = (data) => {
    this.setState({ 'contacts': data }, () => this.props.onSearchAfter(data));
  }

  otherHandle = () => {
    this.setState({ 'otherInput': true });
  }

  render() {
    // console.log(this.props);
    const { onSearchAfter, ...props } = this.props;
    const contacts = this.state.contacts.length > 0 ? this.state.contacts : (props.value.contacts || []);
    if ((!props.value.key || props.list.length === 0) || this.state.otherInput === true) {
      let value = { 'key': props.value.key, 'label': props.value.label };
      if (contacts.length === 0) {
        return <SInput {...{ ...props, ...{ value } }} onChange={(value) => props.onChange(value)} setContacts={this.setContacts} />
      }
      console.log(11111);
      return (
        <Input.Group compact>
          <SInput {...{ ...props, ...{ value } }} style={{ width: '60%' }} onChange={(value) => props.onChange(value)} setContacts={this.setContacts} />
          <SuffixSelect toggleEdit={props.toggleEdit} value={{ key: props.value.supplier_suffix_key }} style={{ width: '40%' }} data={contacts} />
        </Input.Group>
      );
    }
    // add
    // if (!props.value.key) {
    //   return <SInput {...props} value={props.value || []} onChange={(value) => props.onChange(value)} />;
    // }
    if (props.list.length > 0) {
      if (contacts.length === 0) {
        return <TSelect
          {...props}
          value={props.value}
          onChange={(value) => props.onChange(value)} data={props.list}
          otherHandle={() => this.otherHandle()}
        />
      }
      return (
        <Input.Group compact>
          <TSelect
            // style={{ width: '60%' }}
            {...{ ...props, ...{ style: { width: '60%' } } }}
            value={props.value}
            onChange={(value) => props.onChange(value)} data={props.list}
            otherHandle={() => this.otherHandle()}
          />
          <SuffixSelect toggleEdit={props.toggleEdit} value={{ key: props.value.supplier_suffix_key }} style={{ width: '40%' }} data={contacts} />
        </Input.Group>
      );
    }
    return (
      <div>1</div>
    );
  }
}
